const createSlug = (value) =>
  value
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const createServiceEntry = (title, index) => {
  const isHomeService =
    title.toLowerCase().includes("doorstep") ||
    title.toLowerCase().includes("home") ||
    title.toLowerCase().includes("at home");
  const seoFocus = isHomeService
    ? "home massage and spa service"
    : "massage in Pune and premium spa service";

  return {
    id: `service-${index + 1}`,
    title,
    slug: createSlug(title),
    tagline:
      "Sink into a luxury spa experience crafted for comfort, privacy, and deep full-body relaxation.",
    description: `${title} is designed for guests seeking ${seoFocus} with a calm, premium atmosphere. Our team focuses on smooth scheduling, polished service, and a deeply restorative wellness experience that helps you slow down, relax, and feel completely cared for.`,
    about: `If you are looking for ${seoFocus}, this treatment brings together premium massage, spa-style comfort, and relaxation therapy in one seamless experience. The session is arranged to reduce everyday stress, calm physical fatigue, and create a more restful body-mind balance for guests across Pune.`,
    benefits: [
      "Stress relief that helps your mind settle and your body feel lighter",
      "Pain reduction support for common areas of tightness, fatigue, and daily strain",
      "Deep relaxation therapy that promotes comfort, calmness, and better sleep",
      "A premium massage and spa service experience with smooth, guest-first care",
    ],
    whyChoose: [
      "Premium spa service designed for a polished and high-comfort experience",
      "Professional therapists who focus on relaxation, consistency, and personalized care",
      "Strong hygiene standards with fresh setup, clean materials, and attentive service",
      "Comfort-first booking support that makes every session feel easy and reassuring",
    ],
    experience: [
      "Consultation: Share your comfort preferences, pressure needs, and wellness goals before the session begins.",
      "Therapy: Enjoy a premium massage and spa treatment designed to release stress, soften tension, and restore balance.",
      "Relaxation: Finish with a calmer mind, a more comfortable body, and an after-feel that supports better rest.",
    ],
    faqs: [
      {
        question: `What is included in ${title}?`,
        answer:
          "Each session is designed around comfort, relaxation, and professional massage support, with a smooth booking experience and premium spa-style care.",
      },
      {
        question: "Is this service good for stress and tiredness?",
        answer:
          "Yes. Guests often choose this treatment for stress relief, body relaxation, and recovery after long workdays, travel, or physically demanding routines.",
      },
      {
        question: "Can this massage help with better sleep?",
        answer:
          "A calming massage and spa session can help the body unwind, reduce tension, and support a more restful sleep experience afterward.",
      },
      {
        question: "Who should book this spa service?",
        answer:
          "It is ideal for guests who want relaxation therapy, a premium massage experience, and a more convenient wellness option in Pune.",
      },
      {
        question: "How do I book my session?",
        answer:
          "The fastest way is to call our team directly so we can help with availability, guidance, and quick booking support.",
      },
    ],
    ctaLabel: "Call Now",
    image: `/assets/${(index % 11) + 1}-spa.jpg`,
    metaDescription: `${title} for massage in Pune, spa service, home massage, and relaxation therapy with premium booking support from 24 Night Spa.`,
  };
};

export const services = [
  "Full Body Massage In Hinjewadi",
  "Doorstep spa service in Hinjewadi",
  "Doorstep spa service in Pune",
  "Spa Service in Wakad Hinjewadi Pune",
  "Massage Service in Wakad Pune",
  "Massage Service in Hinjewadi Pune",
  "Professional Massage Therapist Wakad",
  "Best Spa in Hinjewadi Pune",
  "Female to male massage in Hinjewadi and Wakad",
  "Home Massage Service Wakad",
  "Home Spa Service Hinjewadi",
  "Doorstep Massage Service Wakad Pune",
  "At Home Spa Service Hinjewadi Pune",
  "Russian spa in Hinjewadi Pune",
  "Spa Near Wakad Hotels",
  "Massage Near Hinjewadi Hotels",
  "Spa Near Me Wakad Pune",
  "Professional Spa Service in Hinjewadi Pune",
].map(createServiceEntry);

export const getServiceBySlug = (slug) =>
  services.find((service) => service.slug === slug);

export const getRelatedServices = (currentSlug) =>
  services.filter((service) => service.slug !== currentSlug).slice(0, 3);

export { createSlug };
